<template>
    <div class="multi-select form-control">
        <div class="list-wrapper">
            <div v-for="x in list" :key="x.value" class="list-item" :class="x.class" @click.prevent.stop="toggleSelected(x)">
                <i class="far fa-check-square" v-if="! x.isHeader && x.selected"></i>
                <i class="far fa-square" v-else-if="! x.isHeader && !x.selected"></i>
                <i class="far fa-check-square" v-else-if="(x.isHeader && x.childrenSelected == 'all')"></i>
                <i class="far fa-square" v-else-if="(x.isHeader && x.childrenSelected == 'none')"></i>
                <i class="fa fa-square" v-else-if="(x.isHeader && x.childrenSelected == 'some')"></i>
                <span>{{ x.text }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { every, forEach, isArray, isObject, keys, map, partialRight, pull, some, sortBy } from 'lodash';

export default {
    props: {
        entries: {
            required: true
        },
        label: {
            type: String,
            default: "",
            required: false
        },
        value: {
            type: Array
        }
    },
    computed: {
        hasListItemWithHeader() {
            return some(this.list, ['isHeader', true]);
        },
        list() {
            let arr;
            if (isArray(this.entries)) {
                const mapEntry = partialRight(this.mapEntry, '', _, _);
                arr = sortBy(map(this.entries, mapEntry), ['text']);
            } else if (isObject(this.entries)) {
                arr = [];
                const headers = sortBy(keys(this.entries));
                forEach(headers, header => {
                    const mapEntry = partialRight(this.mapEntry, `${header}/`, _, _);
                    const children = sortBy(map(keys(this.entries[header]), mapEntry), ['text']);
                    arr.push(this.mapHeader(header, children));
                    arr = [...arr, ...children];
                });
            }
            return arr;
        }
    },
    methods: {
        isSelected(value) {
            return this.value.indexOf(value) >= 0;
        },
        mapEntry(entry, valuePrefix='') {
            if (isObject(entry)) {
                const value = `${valuePrefix}${entry.value}`;
                return {
                    selected: this.isSelected(value),
                    value,
                    text: entry.text
                };
            } else {
                const value = `${valuePrefix}${entry}`;
                return {
                    selected: this.isSelected(value),
                    value,
                    text: entry
                };
            }
        },
        mapHeader(header, children) {
            return {
                class: 'header',
                childrenSelected: every(children, ['selected', true]) ? 'all' : every(children, ['selected', false]) ? 'none' : 'some',
                isHeader: true,
                text: header,
                value: header,
                children: map(children, 'value')
            };
        },
        toggleSelected(x) {
            let newValue = [...this.value];
            if (x.isHeader) {
                switch(x.childrenSelected) {
                    case 'all':
                        pull(newValue, ...x.children);
                        break;
                    case 'none':
                    case 'some':
                        pull(newValue, ...x.children);
                        newValue = [...newValue, ...x.children];
                        break;
                    default:
                }
            } else {
                if (x.selected) {
                    pull(newValue, x.value);
                } else {
                    newValue.push(x.value);
                }
            }
            this.$emit('input', newValue);
        },
    }
}
</script>

<style lang="scss" scoped>
.multi-select {
    height: 150px;
    overflow: auto;

    .list-wrapper {
        .list-item {
            cursor: pointer;
            .fa,
            .far {
                margin-right: 10px;
            }
        }
        .list-item.header {
            font-size: 1.1em;
            font-weight: 700;
            padding-left: 0!important;
        }
        .list-item.header ~ .list-item {
            padding-left: 1em;
        }
    }
}
</style>
